import React, { Component } from 'react';
import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import TextAreaField from '../../components/inputs/textAreaField';
import SectionFooter from '../../components/views/SectionFooter';
import API from '../../utils/API';

const meetingRoomTypeOptions = [
	{ value: 'Meals', label: 'Meals' },
	{ value: 'Meeting', label: 'Meeting' },
	{ value: 'General Session', label: 'General Session' },
	{ value: 'Breakout', label: 'Breakout' },
	{ value: 'Office', label: 'Office' },
	{ value: 'Storage', label: 'Storage' },
	{ value: 'Reception', label: 'Reception' },
	{ value: 'Registration', label: 'Registration' },
	{ value: 'Setup', label: 'Setup' },
	{ value: 'Speaker Ready Room', label: 'Speaker Ready Room' },
	{ value: 'Teardown', label: 'Teardown' },
	{ value: 'Other', label: 'Other' }
];

const spaceConfigurationOptions = [
	{ value: 'Banquet Rounds', label: 'Banquet Rounds' },
	{ value: 'Crescent Rounds', label: 'Crescent Rounds' },
	{ value: 'Theater', label: 'Theater' },
	{ value: 'Schoolroom', label: 'Schoolroom' },
	{ value: 'Conference', label: 'Conference' },
	{ value: 'Reception', label: 'Reception' },
	{ value: 'U-Shape', label: 'U-Shape' },
	{ value: 'Exhibits', label: 'Exhibits' },
	{ value: 'Other', label: 'Other' }
];

class MeetingSpaces extends Component {
	constructor(props) {
		super(props);
		const { venue } = props;
		
		this.state = {
			meetingSpaces: venue.meetingSpaces || [],
			editing: false,
			saving: false,
			expandedSpaces: {}
		};
	}

	addMeetingSpace = () => {
		const { meetingSpaces, expandedSpaces } = this.state;
		const newSpace = {
			meetingRoomType: 'Meeting',
			meetingRoomTypeOther: '',
			functionName: '',
			attendees: 0,
			startTime: '',
			endTime: '',
			spaceConfiguration: 'Theater',
			spaceConfigurationOther: '',
			avRequirements: ''
		};
		
		meetingSpaces.push(newSpace);
		expandedSpaces[meetingSpaces.length - 1] = true;
		
		this.setState({ meetingSpaces, expandedSpaces, editing: true });
	};

	removeMeetingSpace = (index) => {
		const { meetingSpaces } = this.state;
		meetingSpaces.splice(index, 1);
		this.setState({ meetingSpaces, editing: true });
	};

	updateMeetingSpace = (index, field, value) => {
		const { meetingSpaces } = this.state;
		meetingSpaces[index][field] = value;
		this.setState({ meetingSpaces, editing: true });
	};

	toggleSpaceExpanded = (index) => {
		const { expandedSpaces } = this.state;
		expandedSpaces[index] = !expandedSpaces[index];
		this.setState({ expandedSpaces });
	};

	saveDetails = async () => {
		this.setState({ saving: true });
		
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/sourced-venues/${this.props.venueId}`,
				{ meetingSpaces: this.state.meetingSpaces }
			);
			
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (error) {
			console.error('Error saving meeting spaces:', error);
			this.setState({ saving: false });
		}
	};

	cancelEdit = () => {
		const { venue } = this.props;
		this.setState({
			meetingSpaces: venue.meetingSpaces || [],
			editing: false
		});
	};

	render() {
		const { meetingSpaces, editing, expandedSpaces } = this.state;
		const { venue } = this.props;
		
		return (
			<>
				
				<div className="sectionBody">
					<div className="sectionBlock">
						<div className="flex aic jcsb mb-20">
							<h2 className="blockHeader m-0">Meeting Spaces</h2>
							<button className="neu min" onClick={this.addMeetingSpace}>
								<i className="las la-plus mr-10" />
								Add Meeting Space
							</button>
						</div>
						
						{meetingSpaces.length > 0 ? (
							<div>
								{meetingSpaces.map((space, index) => {
									const isExpanded = expandedSpaces[index];
									const roomTypeOption = meetingRoomTypeOptions.find(opt => opt.value === space.meetingRoomType);
									const configOption = spaceConfigurationOptions.find(opt => opt.value === space.spaceConfiguration);
									
									return (
										<div key={index} className="neuCard p-20 mb-15">
											<div className="flex aic jcsb mb-20 c-pointer" onClick={() => this.toggleSpaceExpanded(index)}>
												<div className="flex aic">
													<i className={`las la-angle-${isExpanded ? 'down' : 'right'} mr-15`} style={{ fontSize: '1.2rem' }} />
													<div>
														<h3 className="m-0">
															{space.functionName || `Meeting Space ${index + 1}`}
														</h3>
														<span className="grey small mt-5" style={{ display: 'block' }}>
															{space.meetingRoomType} • {space.attendees} attendees
														</span>
													</div>
												</div>
												<button
													className="p-10 hover-danger"
													onClick={(e) => {
														e.stopPropagation();
														this.removeMeetingSpace(index);
													}}
													title="Remove this space"
												>
													<i className="las la-trash-alt" />
												</button>
											</div>
											
											{isExpanded && (
												<div className="pt-15" style={{ borderTop: '1px solid #eee' }}>
													<div className="flex wrap" style={{ gap: '15px' }}>
														<div style={{ flex: '1 1 250px' }}>
															<SelectField
																label="Meeting Room Type"
																value={roomTypeOption || meetingRoomTypeOptions[0]}
																options={meetingRoomTypeOptions}
																onChange={(option) => this.updateMeetingSpace(index, 'meetingRoomType', option.value)}
															/>
														</div>
														
														{space.meetingRoomType === 'Other' && (
															<div style={{ flex: '1 1 250px' }}>
																<InputField
																	label="Specify Room Type"
																	value={space.meetingRoomTypeOther}
																	onChange={(e) => this.updateMeetingSpace(index, 'meetingRoomTypeOther', e.target.value)}
																	placeholder="Enter room type"
																/>
															</div>
														)}
														
														<div style={{ flex: '1 1 250px' }}>
															<InputField
																label="Function Name"
																value={space.functionName}
																onChange={(e) => this.updateMeetingSpace(index, 'functionName', e.target.value)}
																placeholder="e.g., Keynote, Lunch, Workshop"
															/>
														</div>
													</div>
													
													<div className="flex wrap mt-15" style={{ gap: '15px' }}>
														<div style={{ flex: '1 1 150px' }}>
															<InputField
																label="Number of Attendees"
																type="number"
																value={space.attendees || ''}
																onChange={(e) => this.updateMeetingSpace(index, 'attendees', parseInt(e.target.value) || 0)}
																placeholder="0"
															/>
														</div>
														
														<div style={{ flex: '1 1 150px' }}>
															<InputField
																label="Start Time"
																type="time"
																value={space.startTime}
																onChange={(e) => this.updateMeetingSpace(index, 'startTime', e.target.value)}
															/>
														</div>
														
														<div style={{ flex: '1 1 150px' }}>
															<InputField
																label="End Time"
																type="time"
																value={space.endTime}
																onChange={(e) => this.updateMeetingSpace(index, 'endTime', e.target.value)}
															/>
														</div>
													</div>
													
													<div className="flex wrap mt-15" style={{ gap: '15px' }}>
														<div style={{ flex: '1 1 250px' }}>
															<SelectField
																label="Space Configuration"
																value={configOption || spaceConfigurationOptions[0]}
																options={spaceConfigurationOptions}
																onChange={(option) => this.updateMeetingSpace(index, 'spaceConfiguration', option.value)}
															/>
														</div>
														
														{space.spaceConfiguration === 'Other' && (
															<div style={{ flex: '1 1 250px' }}>
																<InputField
																	label="Specify Configuration"
																	value={space.spaceConfigurationOther}
																	onChange={(e) => this.updateMeetingSpace(index, 'spaceConfigurationOther', e.target.value)}
																	placeholder="Enter configuration type"
																/>
															</div>
														)}
													</div>
													
													<div className="mt-15">
														<TextAreaField
															label="AV Requirements"
															value={space.avRequirements}
															onChange={(e) => this.updateMeetingSpace(index, 'avRequirements', e.target.value)}
															placeholder="Describe AV and technical requirements..."
															rows={2}
														/>
													</div>
												</div>
											)}
										</div>
									);
								})}
							</div>
						) : (
							<div className="text-c p-40">
								<i className="las la-couch" style={{ fontSize: '3rem', color: '#ccc' }} />
								<h3 className="mt-15">No meeting spaces added yet</h3>
								<p className="grey">Click "Add Meeting Space" to define your meeting and function requirements</p>
							</div>
						)}
					</div>
				</div>

				<SectionFooter
					saveEdit={this.saveDetails}
					cancelEdit={this.cancelEdit}
					updatedAt={venue.updatedAt}
					editing={editing}
				/>
			</>
		);
	}
}

export default MeetingSpaces;
